import { NavLink } from "react-router-dom";
import { Home, LayoutGrid, Users, Trophy, User } from "lucide-react";

const items = [
  { to: "/", label: "Ana Sayfa", icon: Home, testId: "nav-home" },
  { to: "/masalar", label: "Masalar", icon: LayoutGrid, testId: "nav-tables" },
  { to: "/arkadaslar", label: "Arkadaşlar", icon: Users, testId: "nav-friends" },
  { to: "/siralama", label: "Sıralama", icon: Trophy, testId: "nav-leaderboard" },
  { to: "/profil", label: "Profil", icon: User, testId: "nav-profile" },
];

export default function BottomNav() {
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 left-0 right-0 z-40 glass border-t border-border safe-bottom lg:hidden"
    >
      <div className="max-w-md mx-auto grid grid-cols-5 h-16 items-center px-2">
        {items.map(({ to, label, icon: Icon, testId }) => (
          <NavLink
            key={to}
            to={to}
            end={to === "/"}
            data-testid={testId}
            className={({ isActive }) =>
              `flex flex-col items-center justify-center gap-1 text-[11px] font-medium transition-colors ${
                isActive ? "text-primary" : "text-muted-foreground hover:text-foreground"
              }`
            }
          >
            {({ isActive }) => (
              <>
                <div
                  className={`h-8 w-8 rounded-full flex items-center justify-center transition-colors ${
                    isActive ? "bg-primary/10" : ""
                  }`}
                >
                  <Icon className="h-5 w-5" strokeWidth={isActive ? 2.4 : 2} />
                </div>
                <span>{label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
